import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";
import { generateQueryParams } from "../../utils/generateQueryParams";

// Fetch all staff members
export const fetchStaffMembers = createAsyncThunk(
  "teamMember/fetchStaffMembers",
  async (params = {}, { rejectWithValue }) => {
    try {
      const queryString = generateQueryParams(params);
      const response = await api.get(
        `/admin/staff${queryString ? `?${queryString}` : ""}`
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch staff members"
      );
    }
  }
);

// Fetch staff member by ID
export const fetchStaffMemberById = createAsyncThunk(
  "teamMember/fetchStaffMemberById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`/admin/staff/${id}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch team member"
      );
    }
  }
);

// Add new staff member
export const addStaffMember = createAsyncThunk(
  "teamMember/addStaffMember",
  async (memberData, { rejectWithValue }) => {
    try {
      const response = await api.post("/admin/staff", memberData);
      return response.data;
    } catch (err) {
      console.error("Error adding staff member:", err);
      return rejectWithValue(
        err.response?.data?.message || "Failed to add staff member"
      );
    }
  }
);

// Update team member
export const updateStaffMember = createAsyncThunk(
  "teamMember/updateStaffMember",
  async ({ id, memberData }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/admin/staff/${id}`, memberData);
      return response.data;
    } catch (err) {
      console.error("Error updating staff member:", err);
      return rejectWithValue(
        err.response?.data?.message || "Failed to update staff member"
      );
    }
  }
);

// Delete team member
export const deleteStaffMember = createAsyncThunk(
  "teamMember/deleteStaffMember",
  async (id) => {
    const response = await api.delete(`/admin/staff/${id}`);
    return response.data;
  }
);

// Search staff members
export const searchStaffMembers = createAsyncThunk(
  "teamMember/searchStaffMembers",
  async (searchParams, { rejectWithValue }) => {
    try {
      const queryString = generateQueryParams(searchParams);
      const response = await api.get(
        `/admin/staff/search${queryString ? `?${queryString}` : ""}`
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to search staff members"
      );
    }
  }
);

// Reset staff member password
export const resetStaffMemberPassword = createAsyncThunk(
  "teamMember/resetStaffMemberPassword",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.patch(`/admin/staff/${id}/reset-password`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to reset staff member password"
      );
    }
  }
);

// Suspend staff member
export const suspendStaffMember = createAsyncThunk(
  "teamMember/suspendStaffMember",
  async (memberId, { rejectWithValue }) => {
    try {
      const response = await api.post(`/admin/staff/${memberId}/suspend`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to suspend staff member"
      );
    }
  }
);

// Reactivate staff member
export const reactivateStaffMember = createAsyncThunk(
  "teamMember/reactivateStaffMember",
  async (memberId, { rejectWithValue }) => {
    try {
      const response = await api.post(`/admin/staff/${memberId}/reactivate`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to reactivate staff member"
      );
    }
  }
);
